// Полный список существующих типов блоков
export const VALID_BLOCK_TYPES = new Set([
  // Hero блоки
  'hero-img',
  'hero-video',
  'hero-img-text-left',
  'hero-video-text-left',
  'hero-img-text-left-button',
  'hero-video-text-left-button',
  'hero-video-text-center',
  'hero-video-text-center-button',
  
  // Текстовые блоки
  'text-block-left',
  'text-block-center',
  'text-block-left-button',
  'text-block-center-button',
  
  // Медиа блоки с изображениями
  'text-left-image-right',
  'image-left-text-right',
  'text-right-image-left',
  'text-top-image-bottom',
  'img-rect-block-text-top-both',
  'img-rect-block-title-left-desc-right-image-bottom',
  'img-rect-block-text-side-left',
  'img-rect-block-text-side-right',
  'img-square-block-text-side-right',
  'img-rect-block-text-top-left',
  
  // Медиа блоки с видео (только простые варианты)
  'text-left-video-right',
  'video-left-text-right',
  'text-right-video-left',
  'text-top-video-bottom',
  
  // Галереи
  'gallery-full-width',
  'gallery-three',
  'gallery-four',
  'gallery-four-two-rows',
  'gallery-dots-photo',
  'gallery-dots-video',
  
  // Отдельные медиа
  'image',
  'video',
  
  // Интерактивные блоки
  'icons-block',
  'list-tips-light',
  'list-tips-dark',
  'faq-lines',
  'faq-cards'
]);

// Конфигурация категорий блоков с параметрами для настройки

export const BLOCK_CATEGORIES = [
  {
    id: 'text',
    name: 'Текстовые блоки',
    description: 'Блоки с текстом и заголовками',
    icon: 'text-block.svg',
    parameters: [
      {
        key: 'alignment',
        label: 'Выравнивание',
        type: 'select',
        options: [
          { value: 'left', label: 'По левому краю' },
          { value: 'center', label: 'По центру' }
        ],
        required: true
      },
      {
        key: 'hasButton',
        label: 'Кнопка',
        type: 'select',
        options: [
          { value: 'none', label: 'Кнопка отключена' },
          { value: 'link', label: 'Кнопка на ссылку' },
          { value: 'form', label: 'Кнопка открытия формы' }
        ],
        required: true
      }
    ],
    fields: [
      { key: 'title', label: 'Заголовок', type: 'string', required: false },
      { key: 'text', label: 'Текст', type: 'text', required: true }
    ],
    getBlockType: (params) => {
      const alignment = params.alignment || 'left';
      const hasButton = params.hasButton || 'none';
      
      if (hasButton === 'none') {
        return `text-block-${alignment}`;
      } else {
        return `text-block-${alignment}-button`;
      }
    },
    getFields: (params) => {
      const fields = [
        { key: 'title', label: 'Заголовок', type: 'string', required: false },
        { key: 'text', label: 'Текст', type: 'text', required: true }
      ];
      if (params.hasButton !== 'none') {
        fields.push({ key: 'button.text', label: 'Текст кнопки', type: 'string', required: true });
        fields.push({ key: 'button.action', label: 'Действие кнопки', type: 'action', required: true });
        if (params.hasButton === 'link') {
          fields.push({ key: 'button.link', label: 'Ссылка', type: 'string', required: true, showWhen: 'hasButton === link' });
        }
      }
      return fields;
    }
  },
  {
    id: 'media',
    name: 'Изображения и видео',
    description: 'Блоки с медиа контентом',
    icon: 'image-video-block.svg',
    parameters: [
      {
        key: 'mediaType',
        label: 'Тип медиа',
        type: 'select',
        options: [
          { value: 'image', label: 'Фото' },
          { value: 'video', label: 'Видео' }
        ],
        required: true
      },
      {
        key: 'fullWidth',
        label: 'На всю ширину',
        type: 'checkbox',
        default: false
      },
      {
        key: 'alignment',
        label: 'Выравнивание',
        type: 'select',
        options: [
          { value: 'text-left', label: 'Текст слева, медиа справа' },
          { value: 'media-left', label: 'Медиа слева, текст справа' },
          { value: 'text-right', label: 'Текст справа, медиа слева' },
          { value: 'text-top', label: 'Текст сверху, медиа снизу' },
          { value: 'text-top-both', label: 'Текст сверху на всю ширину, медиа снизу', imageOnly: true },
          { value: 'text-top-left', label: 'Текст сверху слева, медиа снизу', imageOnly: true },
          { value: 'title-desc-split', label: 'Заголовок слева, описание справа, медиа снизу', imageOnly: true },
          { value: 'media-only', label: 'Только медиа' },
          { value: 'text-center', label: 'Текст по центру', heroOnly: true }
        ],
        required: true,
        showWhen: 'always'
      },
      {
        key: 'contentRatio',
        label: 'Вид контента',
        type: 'select',
        options: [
          { value: 'original', label: 'Исходное соотношение (прямоугольник)' },
          { value: 'square', label: 'Квадрат' }
        ],
        default: 'original',
        showWhen: '!fullWidth && alignment !== media-only && mediaType === image'
      },
      {
        key: 'hasButton',
        label: 'Кнопка',
        type: 'select',
        options: [
          { value: 'none', label: 'Кнопка отключена' },
          { value: 'link', label: 'Кнопка на ссылку' },
          { value: 'form', label: 'Кнопка открытия формы' }
        ],
        default: 'none',
        showWhen: 'alignment !== media-only'
      }
    ],
    fields: [
      { key: 'title', label: 'Заголовок', type: 'string' },
      { key: 'text', label: 'Текст', type: 'text' }
    ],
    getBlockType: (params) => {
      const mediaType = params.mediaType || 'image';
      const fullWidth = params.fullWidth || false;
      const alignment = params.alignment || 'text-left';
      const contentRatio = params.contentRatio || 'original';
      const hasButton = params.hasButton || 'none';
      
      const mediaPrefix = mediaType === 'image' ? 'img' : 'video';
      
      // Hero блоки (fullWidth = true)
      if (fullWidth) {
        let type = `hero-${mediaPrefix}`;
        
        if (alignment === 'media-only') {
          return type;
        }
        
        // Hero поддерживает только text-left и text-center
        if (alignment === 'text-center') {
          type += '-text-center';
        } else {
          // По умолчанию text-left
          type += '-text-left';
        }
        
        if (hasButton !== 'none') {
          type += '-button';
        }
        
        // Валидация: hero-img-text-center-button не существует
        if (VALID_BLOCK_TYPES.has(type)) {
          return type;
        }
        
        // Fallback без кнопки если такой тип не существует
        return `hero-${mediaPrefix}-text-${alignment === 'text-center' ? 'center' : 'left'}`;
      }
      
      // Отдельные медиа блоки
      if (alignment === 'media-only') {
        return mediaType;
      }
      
      // Специальные варианты только для изображений
      if (mediaType === 'image') {
        if (alignment === 'text-top-both') {
          return 'img-rect-block-text-top-both';
        }
        
        if (alignment === 'text-top-left') {
          return 'img-rect-block-text-top-left';
        }
        
        if (alignment === 'title-desc-split') {
          return 'img-rect-block-title-left-desc-right-image-bottom';
        }
        
        // Квадратное изображение - только для media-left
        if (contentRatio === 'square' && alignment === 'media-left') {
          return 'img-square-block-text-side-right';
        }
        
        // Прямоугольные блоки для изображений (rect-block варианты)
        if (contentRatio === 'original') {
          if (alignment === 'text-left') {
            return 'img-rect-block-text-side-left';
          }
          
          if (alignment === 'media-left') {
            return 'img-rect-block-text-side-right';
          }
        }
      }
      
      // Простые варианты для всех медиа (изображения и видео)
      if (alignment === 'text-left') {
        return mediaType === 'image' ? 'text-left-image-right' : 'text-left-video-right';
      }
      
      if (alignment === 'media-left') {
        return mediaType === 'image' ? 'image-left-text-right' : 'video-left-text-right';
      }
      
      if (alignment === 'text-right') {
        return mediaType === 'image' ? 'text-right-image-left' : 'text-right-video-left';
      }
      
      if (alignment === 'text-top') {
        return mediaType === 'image' ? 'text-top-image-bottom' : 'text-top-video-bottom';
      }
      
      // Fallback
      return mediaType === 'image' ? 'text-left-image-right' : 'text-left-video-right';
    },
    getFields: (params) => {
      const fields = [];
      const mediaType = params.mediaType || 'image';
      const alignment = params.alignment || 'text-left';
      const hasButton = params.hasButton || 'none';
      const urlKey = mediaType === 'image' ? 'image_url' : 'video_url';
      
      // Медиа поле всегда нужно
      fields.push({ 
        key: urlKey, 
        label: `${mediaType === 'image' ? 'Изображение' : 'Видео'}`, 
        type: 'media', 
        required: true 
      });
      
      // Текстовые поля если не только медиа
      if (alignment !== 'media-only') {
        fields.push({ key: 'title', label: 'Заголовок', type: 'string', required: false });
        fields.push({ key: 'text', label: 'Текст', type: 'text', required: false });
      }
      
      // Поля кнопки
      if (hasButton !== 'none' && alignment !== 'media-only') {
        fields.push({ key: 'button.text', label: 'Текст кнопки', type: 'string', required: true });
        fields.push({ key: 'button.action', label: 'Действие кнопки', type: 'action', required: true });
        if (hasButton === 'link') {
          fields.push({ key: 'button.link', label: 'Ссылка', type: 'string', required: true });
        }
      }
      
      return fields;
    }
  },
  {
    id: 'gallery',
    name: 'Галереи',
    description: 'Блоки с множественными изображениями или видео',
    icon: 'gallery-block.svg',
    parameters: [
      {
        key: 'mediaType',
        label: 'Тип медиа',
        type: 'select',
        options: [
          { value: 'image', label: 'Изображения' },
          { value: 'video', label: 'Видео' }
        ],
        required: true
      },
      {
        key: 'layout',
        label: 'Расположение',
        type: 'select',
        options: [
          { value: 'full-width', label: 'Галерея на всю ширину' },
          { value: 'three', label: 'Галерея из трех элементов' },
          { value: 'four', label: 'Галерея из четырех элементов' },
          { value: 'four-rows', label: 'Галерея из четырех элементов в два ряда' },
          { value: 'dots', label: 'Слайдер с точками навигации' }
        ],
        required: true
      }
    ],
    fields: [
      { key: 'title', label: 'Заголовок', type: 'string', required: false }
    ],
    getBlockType: (params) => {
      const mediaType = params.mediaType || 'image';
      const layout = params.layout || 'full-width';
      
      const layoutMap = {
        'full-width': 'gallery-full-width',
        'three': 'gallery-three',
        'four': 'gallery-four',
        'four-rows': 'gallery-four-two-rows',
        'dots': mediaType === 'image' ? 'gallery-dots-photo' : 'gallery-dots-video'
      };
      
      return layoutMap[layout] || 'gallery-full-width';
    },
    getCollection: (params) => {
      const mediaType = params.mediaType || 'image';
      const collectionKey = mediaType === 'image' ? 'images' : 'videos';
      
      return {
        key: collectionKey,
        label: mediaType === 'image' ? 'Изображения' : 'Видео',
        itemFields: [
          { 
            key: mediaType === 'image' ? 'image_url' : 'video_url', 
            label: `${mediaType === 'image' ? 'Изображение' : 'Видео'}`, 
            type: 'media', 
            required: true 
          },
          { key: 'title', label: 'Подпись', type: 'string' },
          { key: 'description', label: 'Описание', type: 'text' }
        ]
      };
    }
  },
  {
    id: 'interactive',
    name: 'Интерактивные блоки',
    description: 'Блоки с иконками, FAQ и другими интерактивными элементами',
    icon: 'interactive-block.svg',
    parameters: [
      {
        key: 'blockType',
        label: 'Тип блока',
        type: 'select',
        options: [
          { value: 'icons', label: 'Блок с иконками и описаниями' },
          { value: 'list-tips-light', label: 'Список советов (светлая тема)' },
          { value: 'list-tips-dark', label: 'Список советов (темная тема)' },
          { value: 'faq-lines', label: 'FAQ в виде линий' },
          { value: 'faq-cards', label: 'FAQ в виде карточек' }
        ],
        required: true
      },
      {
        key: 'theme',
        label: 'Тема',
        type: 'select',
        options: [
          { value: 'light', label: 'Светлая' },
          { value: 'dark', label: 'Темная' }
        ],
        default: 'light',
        showWhen: 'blockType === list-tips-light || blockType === list-tips-dark'
      }
    ],
    fields: [
      { key: 'title', label: 'Заголовок', type: 'string', required: false }
    ],
    getBlockType: (params) => {
      const blockType = params.blockType || 'icons';
      
      const typeMap = {
        'icons': 'icons-block',
        'list-tips-light': 'list-tips-light',
        'list-tips-dark': 'list-tips-dark',
        'faq-lines': 'faq-lines',
        'faq-cards': 'faq-cards'
      };
      
      return typeMap[blockType] || 'icons-block';
    },
    getFields: () => {
      return [
        { key: 'title', label: 'Заголовок', type: 'string', required: false }
      ];
    },
    getCollection: (params) => {
      const blockType = params.blockType || 'icons';
      
      if (blockType === 'icons') {
        return {
          key: 'items',
          label: 'Элементы',
          itemFields: [
            { key: 'title', label: 'Заголовок', type: 'string', required: true },
            { key: 'description', label: 'Описание', type: 'text' },
            { key: 'svg_link', label: 'Ссылка на SVG', type: 'string' }
          ]
        };
      } else if (blockType === 'list-tips-light' || blockType === 'list-tips-dark') {
        return {
          key: 'items',
          label: 'Советы',
          itemFields: [
            { key: 'text', label: 'Текст совета', type: 'string', required: true }
          ]
        };
      } else {
        return {
          key: 'items',
          label: 'Вопросы и ответы',
          itemFields: [
            { key: 'question', label: 'Вопрос', type: 'string', required: true },
            { key: 'answer', label: 'Ответ', type: 'text', required: true }
          ]
        };
      }
    }
  }
];

// Функции для работы с блоками
export function getBlockConfigByType(type) {
  for (const category of BLOCK_CATEGORIES) {
    // Проверяем, может ли категория генерировать этот тип
    if (category.getBlockType) {
      // Для существующих блоков пытаемся найти конфигурацию
      const testParams = {};
      if (type.includes('text-block')) {
        testParams.alignment = type.includes('center') ? 'center' : 'left';
        testParams.hasButton = type.includes('button') ? 'link' : 'none';
      } else if (type.includes('hero')) {
        testParams.backgroundType = type.includes('img') ? 'image' : 'video';
        testParams.textAlignment = type.includes('center') ? 'center' : 'left';
        testParams.hasButton = type.includes('button') ? 'link' : 'none';
      } else if (type.includes('img-') || type.includes('text-left-') || type.includes('text-right-') || type.includes('text-top-') || type.includes('image-left-') || type.includes('image-right-') || type.includes('video-')) {
        // Определяем тип медиа на основе типа блока
        if (type.includes('video-')) {
          testParams.mediaType = 'video';
        } else {
          testParams.mediaType = 'image';
        }
        
        // Определяем layout для медиа блоков на основе типа блока
        if (type.includes('text-left-video-right') || type.includes('text-left-image-right')) {
          testParams.layout = 'text-left-image-right';
        } else if (type.includes('video-left-text-right') || type.includes('image-left-text-right')) {
          testParams.layout = 'image-left-text-right';
        } else if (type.includes('text-right-video-left') || type.includes('text-right-image-left')) {
          testParams.layout = 'text-right-image-left';
        } else if (type.includes('text-top-video-bottom') || type.includes('text-top-image-bottom')) {
          testParams.layout = 'text-top-image-bottom';
        } else if (type.includes('video-square-block-text-side-right') || type.includes('img-square-block-text-side-right')) {
          testParams.layout = 'square-right';
        } else if (type.includes('video-rect-block-text-side-left') || type.includes('img-rect-block-text-side-left')) {
          testParams.layout = 'rect-left';
        } else if (type.includes('video-rect-block-text-side-right') || type.includes('img-rect-block-text-side-right')) {
          testParams.layout = 'rect-right';
        } else if (type.includes('video-rect-block-text-top-left') || type.includes('img-rect-block-text-top-left')) {
          testParams.layout = 'rect-top-left';
        } else if (type.includes('video-rect-block-text-top-both') || type.includes('img-rect-block-text-top-both')) {
          testParams.layout = 'rect-top-center';
        } else if (type.includes('video-rect-block-title-left-desc-right-video-bottom') || type.includes('img-rect-block-title-left-desc-right-image-bottom')) {
          testParams.layout = 'rect-title-left-desc-right';
        } else {
          testParams.layout = 'single';
        }
      } else if (type === 'image' || type === 'video') {
        testParams.mediaType = type;
        testParams.layout = 'single';
      }
      
      if (category.getBlockType(testParams) === type) {
        return {
          type,
          label: category.name,
          fields: category.getFields ? category.getFields(testParams) : category.fields,
          collection: category.getCollection ? category.getCollection(testParams) : null
        };
      }
    }
  }
  
  // Fallback для существующих блоков
  const fallbackConfigs = {
    'text-block-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }] },
    'text-block-center': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }] },
    'text-block-left-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    'text-block-center-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    
    // Медиа блоки (изображения)
    'text-left-image-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'image-left-text-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'text-right-image-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'text-top-image-bottom': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-square-block-text-side-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-rect-block-text-side-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-rect-block-text-side-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-rect-block-text-top-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-rect-block-text-top-both': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'img-rect-block-title-left-desc-right-image-bottom': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    
    // Медиа блоки (видео)
    'text-left-video-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-left-text-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'text-right-video-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'text-top-video-bottom': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-square-block-text-side-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-rect-block-text-side-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-rect-block-text-side-right': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-rect-block-text-top-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-rect-block-text-top-both': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'video-rect-block-title-left-desc-right-video-bottom': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    
    // Hero блоки
    'hero-video': { fields: [{ key: 'video_url', label: 'Ссылка на видео' }] },
    'hero-img': { fields: [{ key: 'image_url', label: 'Ссылка на изображение' }] },
    'hero-img-text-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'hero-video-text-left': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'hero-img-text-center': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }] },
    'hero-video-text-center': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }] },
    'hero-img-text-left-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    'hero-video-text-left-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    'hero-img-text-center-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'image_url', label: 'Ссылка на изображение' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    'hero-video-text-center-button': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'text', label: 'Текст' }, { key: 'video_url', label: 'Ссылка на видео' }, { key: 'button.text', label: 'Текст кнопки' }, { key: 'button.action', label: 'Действие кнопки' }] },
    
    // Галереи
    'gallery-full-width': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'images', label: 'Изображения', itemFields: [{ key: 'image_url', label: 'Ссылка на изображение' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    'gallery-four': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'images', label: 'Изображения', itemFields: [{ key: 'image_url', label: 'Ссылка на изображение' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    'gallery-four-two-rows': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'images', label: 'Изображения', itemFields: [{ key: 'image_url', label: 'Ссылка на изображение' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    'gallery-three': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'images', label: 'Изображения', itemFields: [{ key: 'image_url', label: 'Ссылка на изображение' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    'gallery-dots-photo': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'images', label: 'Изображения', itemFields: [{ key: 'image_url', label: 'Ссылка на изображение' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    'gallery-dots-video': { fields: [{ key: 'title', label: 'Заголовок' }], collection: { key: 'videos', label: 'Видео', itemFields: [{ key: 'video_url', label: 'Ссылка на видео' }, { key: 'title', label: 'Подпись' }, { key: 'description', label: 'Описание' }] } },
    
    // Отдельные медиа блоки
    'image': { fields: [{ key: 'image.image_url', label: 'Ссылка на изображение' }, { key: 'image.title', label: 'Подпись' }, { key: 'image.description', label: 'Описание' }] },
    'video': { fields: [{ key: 'video_url', label: 'Ссылка на видео' }, { key: 'image.image_url', label: 'Постер' }, { key: 'image.title', label: 'Подпись' }, { key: 'image.description', label: 'Описание' }] },
    
    // List tips блоки
    'list-tips-light': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'align', label: 'Выравнивание' }], collection: { key: 'items', label: 'Советы', itemFields: [{ key: 'text', label: 'Текст совета' }] } },
    'list-tips-dark': { fields: [{ key: 'title', label: 'Заголовок' }, { key: 'align', label: 'Выравнивание' }], collection: { key: 'items', label: 'Советы', itemFields: [{ key: 'text', label: 'Текст совета' }] } }
  };
  
  if (fallbackConfigs[type]) {
    return { type, ...fallbackConfigs[type] };
  }
  
  return null;
}

export function listBlockTypeOptions() {
  const options = [];
  for (const category of BLOCK_CATEGORIES) {
    options.push({ value: category.id, label: category.name });
  }
  return options;
}

export function getBlockCategories() {
  return BLOCK_CATEGORIES;
}

